import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// components
import CartSummaryMember from '../../_molecules/CartSummaryMember';
import CaretDownIcon from '@icons/CaretDownIcon';
import CaretUpIcon from '@icons/CaretUpIcon';
import { BodyMedium, BodySmall } from '@styled';

// functionality
import colors from '@general/colors';
import { formatMoney } from '@general/helpers/currency.helpers';
import useCartFromAPI from '@hooks/apiLegacy/useCartFromAPI';
import useCartItemsGroupedByMember from '@hooks/useCartItemsGroupedByMember';
import useViewer from '@hooks/useViewer';

const HeadingStyled = styled(BodyMedium)`
    font-weight: 700;
`;

const CartSummaryItems = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { viewer } = useViewer();
    const { cart } = useCartFromAPI({ viewerId: viewer?.recordId });
    const { itemsGroupedByMember } = useCartItemsGroupedByMember({
        cart,
        itemCount: cart ? cart.items.length : null,
        total: cart?.total,
    });

    const displayStoreCredit = () => {
        const { appliedStoreCredit } = cart?._calculated;
        if (appliedStoreCredit === 0) return null;

        return (
            <div className="flex justify-between">
                <div className="flex flex-column">
                    <BodySmall className="text-admiral">Store Credit</BodySmall>
                </div>
                <BodySmall className="ml-1rem text-admiral">
                    <>-{formatMoney(appliedStoreCredit, cart.locale)}</>
                </BodySmall>
            </div>
        );
    };

    if (!itemsGroupedByMember) {
        return null;
    }

    return (
        <div>
            <div className="flex items-center justify-between">
                <HeadingStyled>Items</HeadingStyled>
                <a
                    href="#"
                    className="flex items-center justify-between"
                    style={{ color: colors.azure }}
                    onClick={e => {
                        e.preventDefault();
                        setIsOpen(!isOpen);
                    }}
                >
                    <BodySmall className="mr-0.5rem">{isOpen ? 'Hide' : 'Show'}</BodySmall>
                    {isOpen && <CaretUpIcon color={colors.azure} />}
                    {!isOpen && <CaretDownIcon color={colors.azure} />}
                </a>
            </div>

            {isOpen && (
                <div className="mt-1rem">
                    <div className="mb-1rem">{cart._calculated?.appliedStoreCredit > 0 && displayStoreCredit()}</div>
                    {itemsGroupedByMember.map(memberGroup => {
                        return <CartSummaryMember key={memberGroup.memberId} {...memberGroup} />;
                    })}
                </div>
            )}
        </div>
    );
};

CartSummaryItems.propTypes = {
    //
};

export default CartSummaryItems;
